var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2225_",
    d: "M40,55.5c0-1.9-1.6-3.5-3.5-3.5h-13c-1.9,0-3.5,1.6-3.5,3.5v13c0,1.9,1.6,3.5,3.5,3.5h13 c1.9,0,3.5-1.6,3.5-3.5V55.5z M27,59h6v6h-6V59z M90.9,25.4l-8.9-9V6c0-2.2-1.8-4-4.1-4H14.1C11.8,2,10,3.8,10,6v10.4l-8.9,9 C0.4,26.1,0,27.1,0,28.2v10.2C0,40.6,1.8,42,4,42h84c2.2,0,4-1.4,4-3.7V28.2C92,27.1,91.6,26.1,90.9,25.4z M74,10v5H18v-5H74z  M84,34H8v-4.2l8.2-7.8h59.6l8.2,7.8V34z M86,50.1V86c0,2.2-1.8,4-4,4H68.3c-2.2,0-4-1.6-4-3.8l0-21.2H55v21c0,2.2-1.9,4-4.1,4H10.1 C7.9,90,6,88.2,6,86V50.1c0-2.2,1.8-4,4-4s4,1.8,4,4V82h33V60.6c0-2.2,1.7-3.6,3.9-3.6h17.3c2.2,0,3.7,1.4,3.7,3.6V82h6V50.1 c0-2.2,1.8-4,4-4S86,47.9,86,50.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.4fd4ccc6dbf9d52dffdedd283be15523.svg";
export { ForwardRef as ReactComponent };